/* Mobile swipe gallery on the product detail page.
   Touch swipe + snapping are pure CSS (scroll-snap). This script only moves the
   active .pdp__dash to match the image in view, via a passive scroll listener on
   the track. Unlike the collection-card gallery there is no wrapping link, so no
   tap-vs-swipe handling is needed. Only classes are toggled — never inline styles
   — so this can't collide with the data-cascade scroll-reveal in animations.js.
   On desktop the track is display:contents (never scrollable), so the handler
   self-no-ops. */
(function () {
  if (window.__pdpGalleryInit) return;
  window.__pdpGalleryInit = true;

  function initGallery(gallery) {
    if (gallery.dataset.pdpGalleryInit === '1') return;

    var track = gallery.querySelector('.pdp__gallery-track');
    var dashes = gallery.querySelectorAll('.pdp__dash');
    if (!track || dashes.length < 2) return;

    gallery.dataset.pdpGalleryInit = '1';

    var ticking = false;
    function sync() {
      ticking = false;
      var width = track.clientWidth;
      if (!width) return; // display:contents (desktop) → not scrollable
      var index = Math.round(track.scrollLeft / width);
      if (index < 0) index = 0;
      if (index > dashes.length - 1) index = dashes.length - 1;
      for (var i = 0; i < dashes.length; i++) {
        dashes[i].classList.toggle('is-active', i === index);
      }
    }
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );
    sync();
  }

  function scan(root) {
    (root || document).querySelectorAll('.pdp__gallery').forEach(initGallery);
  }

  function start() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-scan when a section re-renders (theme editor).
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
